export default __webpack_public_path__ + "static/uc-trunk-shows-54854fd5288fa770c48cec83f30abc54.png";